module.exports = __webpack_public_path__ + "media/images/flags/DK-75f7149dc8678f60ac3d78449754da21.svg";